import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MasipService } from '../../services/masip.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-delete-confirmation',
  standalone: false,
  templateUrl: './delete-confirmation.component.html',
  styleUrl: './delete-confirmation.component.scss'
})
export class DeleteConfirmationComponent {

  isGroup: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DeleteConfirmationComponent>,
    private masipService: MasipService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { profile: any, },
  ) { }


  ngOnInit(): void {
    if (this.router.url === '/grupos') {
      this.isGroup = true;
    } 
    
  }

  closeDialog() {
    this.dialogRef.close();
  }

  deleteProfile() {
    if (this.isGroup) {
      this.masipService.deleteGroup(this.data.profile.id).subscribe((resp: any) => {
        this.dialogRef.close('eliminado');
      });
    } else {
     this.masipService.deleteProfile(this.data.profile.id).subscribe((resp: any) => {
       this.dialogRef.close('eliminado');
     });
    }
  }
}
